import SwishError from './SwishError';

export default class NetworkError extends SwishError {
  isNetworkError() { return true; }
}
